import { Chip, ChipProps } from '@mui/material';
import { FC } from 'react';

type StatusLabelProps = {
  label: string;
  backgroundColor: string;
  color: string;
} & Omit<ChipProps, 'label' | 'color'>;

export const StatusLabel: FC<StatusLabelProps> = ({ label, backgroundColor, color, ...props }) => {
  return (
    <Chip
      label={label}
      sx={{
        backgroundColor,
        color,
        fontWeight: 500,
        fontSize: '0.875rem',
        ...props.sx,
      }}
    />
  );
};
